@if (loading) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
}
@if (!loading) {
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<h2>{{ purchase ? 'Edit Purchase' : 'Create Purchase' }}</h2>
		<nz-form-item>
			<nz-form-label>Purchase Date</nz-form-label>
			<nz-form-control>
				<nz-date-picker formControlName="purchase_date"></nz-date-picker>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item
			style="max-width: 250px"
			nz-tooltip
			nzTooltipTitle="Replace with 3rd party invoice ID if one is available such as from sales force."
		>
			<nz-form-label>Invoice ID</nz-form-label>
			<nz-form-control>
				<input nz-input formControlName="invoice_id" placeholder="Enter Invoice ID" />
			</nz-form-control>
		</nz-form-item>
		<nz-divider nzText="Purchase Items"></nz-divider>
		<div formArrayName="items">
			<nz-table nzBordered>
				<thead>
					<tr>
						<th>Purchase Type</th>
						<th>License Type</th>
						<th>Product</th>
						<th>License ID</th>
						<th>Count</th>
						<th>License Range</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					@for (item of itemsArray.controls; track item; let i = $index) {
						<tr [formGroupName]="i">
							<td>
								@if (!purchase) {
									<nz-form-item style="min-width: 110px">
										<nz-form-control>
											<nz-select formControlName="purchase_type" [nzLoading]="!purchaseTypes">
												@for (purchase of purchaseTypes; track purchase) {
													<nz-option
														[nzValue]="purchase.type"
														[nzLabel]="purchase.type"
													></nz-option>
												}
											</nz-select>
										</nz-form-control>
									</nz-form-item>
								}
								@if (purchase) {
									{{ itemsArray.at(i).get('purchase_type')?.value }}
								}
							</td>
							<td>
								@if (itemsArray.at(i).get('purchase_type')?.value !== Purchases.ADD_ON) {
									<nz-form-item style="min-width: 110px">
										<nz-form-control>
											<nz-select formControlName="license_type" [nzLoading]="!licenseTypes">
												@for (license of licenseTypes; track license) {
													<nz-option
														[nzValue]="license.type"
														[nzLabel]="license.type"
													></nz-option>
												}
											</nz-select>
										</nz-form-control>
									</nz-form-item>
								}
							</td>
							<td>
								@if (itemsArray.at(i).get('purchase_type')?.value !== Purchases.ADD_ON) {
									<nz-form-item style="min-width: 100px">
										<nz-form-control>
											<nz-select formControlName="product_name" [nzLoading]="!products">
												@for (product of products; track product) {
													<nz-option
														[nzValue]="product.name"
														[nzLabel]="product.name"
													></nz-option>
												}
											</nz-select>
										</nz-form-control>
									</nz-form-item>
								}
							</td>
							<td>
								@if (itemsArray.at(i).get('purchase_type')?.value === Purchases.ADD_ON) {
									<nz-form-item style="min-width: 100px">
										<nz-form-control>
											<nz-select formControlName="license_id" [nzLoading]="!licenseIds">
												@for (licenseId of licenseIds; track licenseId) {
													<nz-option [nzValue]="licenseId" [nzLabel]="licenseId"></nz-option>
												}
											</nz-select>
										</nz-form-control>
									</nz-form-item>
								}
								@if (purchase && itemsArray.at(i).get('purchase_type')?.value !== Purchases.ADD_ON) {
									{{ itemsArray.at(i).get('license_id')?.value }}
								}
							</td>
							<td>
								<nz-form-item>
									<nz-form-control>
										<nz-input-number formControlName="count" [nzMin]="1"></nz-input-number>
									</nz-form-control>
								</nz-form-item>
							</td>
							<td>
								@if (itemsArray.at(i).get('purchase_type')?.value !== Purchases.ADD_ON) {
									<nz-form-item style="min-width: 100px">
										<nz-form-control>
											<nz-date-picker
												formControlName="start_date"
												nzPlaceHolder="Start"
											></nz-date-picker>
										</nz-form-control>
									</nz-form-item>
									<nz-form-item style="min-width: 100px">
										<nz-form-control>
											<nz-date-picker
												formControlName="end_date"
												nzPlaceHolder="End"
											></nz-date-picker>
										</nz-form-control>
									</nz-form-item>
								}
							</td>
							<td>
								@if (itemsArray.controls.length > 1 && !purchase) {
									<button nz-button nzDanger (click)="removeItem(i)">Remove Item</button>
								}
							</td>
						</tr>
					}
				</tbody>
				<ng-template #noData>
					<nz-typography>No purchases available</nz-typography>
				</ng-template>
			</nz-table>
			@if (!purchase) {
				<button nz-button nzType="default" (click)="addItem()">Add Item</button>
			}
		</div>
		<div class="buttons">
			<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
			<button nz-button type="button" (click)="clear()">Clear</button>
		</div>
	</form>
}
